<div class="mx-auto max-w-6xl p-6 sm:p-8">
  <div class="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">Klubi</h1>
      <p class="mt-1 text-gray-600">Dodajajte in urejajte klube za svojo enoto.</p>
    </div>
    <button type="button" class="rounded-lg bg-blue-600 px-5 py-3 font-semibold text-white shadow-md transition hover:bg-blue-700" (click)="startAdd()">
      <i class="fas fa-plus mr-2"></i>Dodaj klub
    </button>
  </div>

  <div *ngIf="error" class="mb-5 rounded-lg bg-red-100 px-4 py-3 font-semibold text-red-700">{{ error }}</div>

  <div class="mb-5">
    <label for="clubSearch" class="sr-only">Išči klub</label>
    <div class="relative max-w-xl">
      <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
      <input id="clubSearch" type="search" placeholder="Išči po imenu ali kodi kluba" class="w-full rounded-lg border border-gray-300 bg-white py-3 pl-10 pr-3" [(ngModel)]="search" (ngModelChange)="applySearch()" />
    </div>
  </div>

  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg">
    <div *ngIf="loading" class="p-8 text-center text-gray-500"><i class="fas fa-spinner fa-spin mr-2"></i>Nalagam klube...</div>
    <table *ngIf="!loading && filteredClubs.length" class="w-full border-collapse">
      <thead class="bg-blue-600 text-white">
        <tr>
          <th class="px-5 py-3 text-left">ID</th>
          <th class="px-5 py-3 text-left">Ime kluba</th>
          <th class="px-5 py-3 text-left">Koda</th>
          <th class="px-5 py-3 text-right">Akcije</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr *ngFor="let club of filteredClubs" class="hover:bg-blue-50">
          <td class="px-5 py-4 text-gray-500">{{ club.club_id }}</td>
          <td class="px-5 py-4 font-semibold text-gray-800">{{ club.name }}</td>
          <td class="px-5 py-4 text-gray-600">{{ club.code || '-' }}</td>
          <td class="px-5 py-4 text-right">
            <button type="button" class="rounded-lg bg-blue-50 px-3 py-2 font-semibold text-blue-700 hover:bg-blue-100" (click)="startEdit(club)">
              <i class="fas fa-edit mr-1"></i>Uredi
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!loading && !filteredClubs.length" class="p-10 text-center text-gray-500">Ni najdenih klubov.</div>
  </div>
</div>

<div *ngIf="clubDialogOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 backdrop-blur-sm">
  <app-club-add-dialog [club]="selectedClub" [existingClubs]="clubs" (save)="onDialogSave()" (cancel)="cancelEdit()"></app-club-add-dialog>
</div>
